import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { API_ENDPOINTS } from '@/constants/api-endpoints';
import { getContactByThreadId, updateContactByThreadId } from '@/services/contactService';
import { ContactDetailsResponse } from '@/types/contact';

export const useContact = (threadId: string | null) => {
  return useQuery<ContactDetailsResponse>({
    queryKey: ['contact', threadId],
    queryFn: () => getContactByThreadId(threadId!),
    enabled: !!threadId,
  });
};

export const useUpdateContact = (chatToken?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ threadId, data }: { threadId: string; data: Partial<ContactDetailsResponse['contactInfo']> }) =>
      updateContactByThreadId(threadId, data),
    onSuccess: (_, variables) => {
      // Invalidate contact query
      queryClient.invalidateQueries({ queryKey: ['contact', variables.threadId] });
      
      // Invalidate threads query (vendor-scoped)
      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return Array.isArray(key) &&
                 key.length >= 1 &&
                 key[0] === API_ENDPOINTS.getThreadDetails;
        },
      });
    },
  });
};
